import { render } from "./TransferenciasCriadas.vue?vue&type=template&id=fb6f6098&scoped=true"
import script from "./TransferenciasCriadas.vue?vue&type=script&lang=js"
export * from "./TransferenciasCriadas.vue?vue&type=script&lang=js"

import "./TransferenciasCriadas.vue?vue&type=style&index=0&id=fb6f6098&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6f6098"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTd,QPagination});
